import { User } from '@/services/types'
import { AuthMutations } from './types'

const mutations: AuthMutations = {
  setAccessToken(state, accessToken: string | null) {
    state.accessToken = accessToken
  },
  setUser(state, user: User | null) {
    state.user = user
  },
  setIsShowAuthIframe(state, value:boolean ) {
    state.isShowAuthIframe = value
  },
}

export default mutations
